import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useDemo } from '../providers/DemoProvider';
import { GAME_REGISTRY } from '../../games/models/GameRegistry';
import { Link } from 'react-router-dom';
import { PACKS } from '../../../data/packs';

const DemoGamePlayer: React.FC = () => {
  const { gameId } = useParams<{ gameId: string }>();
  const { addMuseCash, equippedMuseId } = useDemo();
  const game = gameId ? GAME_REGISTRY[gameId] : null;
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const allMuses = Object.values(PACKS).flatMap(p => p.muses);
  const equippedMuse = allMuses.find(m => m.name === equippedMuseId);

  useEffect(() => {
    const handleGameMessage = (event: MessageEvent) => {
      if (event.source !== iframeRef.current?.contentWindow) {
        return;
      }
      if (event.data.type === 'REQUEST_MUSE_IMAGE' && equippedMuse) {
        iframeRef.current?.contentWindow?.postMessage({
          type: 'MUSE_IMAGE_RESPONSE',
          payload: { imageUrl: equippedMuse.img }
        }, '*');
      }
    };

    window.addEventListener('message', handleGameMessage);

    const timer = setInterval(() => {
      addMuseCash(1);
    }, 1000);

    return () => {
      clearInterval(timer);
      window.removeEventListener('message', handleGameMessage);
    };
  }, [addMuseCash, equippedMuse]);

  if (!game) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Game not found!</h2>
        <p>This game might be under construction or the link is incorrect.</p>
        <Link to="/demo/games" className="button">Back to Games</Link>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 80px)' }}>
      <div style={{ padding: '1rem', background: '#f0f0f0', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ margin: 0, fontSize: '1.5rem' }}>{game.title}</h1>
        <Link to="/demo/games" style={{ textDecoration: 'none', background: '#039be5', color: 'white', padding: '0.5rem 1rem', borderRadius: '8px', fontWeight: 'bold' }}>
          ← Back to Games
        </Link>
      </div>
      <iframe
        ref={iframeRef}
        src={game.gameUrl}
        title={game.title}
        style={{ flex: 1, border: 'none' }}
        allowFullScreen
      />
    </div>
  );
};

export default DemoGamePlayer;
